/**
 * Pure presentation data for the one-player journey.
 *
 * Keeping opponent selection and difficulty ordering here makes the UI predictable and gives
 * browser tooling a small dependency-free contract to verify.
 */

export const AI_DIFFICULTY_OPTIONS = Object.freeze([
  Object.freeze({
    id: 'rookie',
    label: 'Rookie',
    note: 'Long reactions · frequent openings',
    detail: 'A patient first opponent. Gives you time to recognise attacks and answer.',
  }),
  Object.freeze({
    id: 'club',
    label: 'Club',
    note: 'Measured reactions · readable pressure',
    detail: 'Uses the full ruleset, but leaves clear gaps after risky choices.',
  }),
  Object.freeze({
    id: 'skilled',
    label: 'Skilled',
    note: 'Adaptive neutral · balanced punishment',
    detail: 'The intended first run: observes habits, contests space, and punishes obvious misses.',
  }),
  Object.freeze({
    id: 'veteran',
    label: 'Veteran',
    note: 'Fast adaptation · strong defence',
    detail: 'Recognises repeated patterns quickly and converts more of your mistakes.',
  }),
  Object.freeze({
    id: 'iron',
    label: 'Iron',
    note: 'Minimal hesitation · ruthless punishment',
    detail: 'A severe computer rival with tight reactions and very few deliberate errors.',
  }),
]);

export const AI_DIFFICULTY_IDS = Object.freeze(AI_DIFFICULTY_OPTIONS.map((o) => o.id));

/** The computer always occupies slot 1 and takes a different roster entry when one exists. */
export function computerOpponent(roster, humanId) {
  if (!Array.isArray(roster) || roster.length === 0) return null;
  for (const fighter of roster) {
    if (fighter && fighter.id !== humanId) return fighter;
  }
  return roster[0] || null;
}

export function difficultyIndex(id) {
  const index = AI_DIFFICULTY_IDS.indexOf(id);
  return index >= 0 ? index : AI_DIFFICULTY_IDS.indexOf('skilled');
}
